module.exports = __webpack_public_path__ + "img/folder-empty.134c4df8.svg";